import { parseDomain } from '@wix/domains-serverless-interface';
const BROKER_PAGE_URL = 'https://manage.wix.com/premium-domains/domain-broker';
export const buildBrokerUrl = _ref => {
  let domainName = _ref.domainName,
    msid = _ref.msid;
  return `${BROKER_PAGE_URL}?${new URLSearchParams({
    domainName: parseDomain(domainName).asciiDomain,
    ...(msid && {
      msid
    })
  }).toString()}`;
};
//# sourceMappingURL=brokerUrl.js.map